import axios from "axios";
const BASE_API_URL = process.env.REACT_APP_API_URL;

// here from new api
export const Get_Countries = `${BASE_API_URL}/Country/Country_GetList_Active`;
// export const Send_Otp_With_Registration = `${BASE_API_URL}/RamNamBook/SendOtp_WithRegistration`;
// export const VerifyOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/VerifyOtp_RamNamBook`;
// export const ResendOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/ResendOtp_RamNamBook2`;
export const Send_Login_Otp = `${BASE_API_URL}/RamNamBook/SendLogin_Otp2`;
export const Verify_Login_Otp = `${BASE_API_URL}/RamNamBook/VerifyLogin_Otp`;
// -------------------------------------------
export const Get_Member_Total_Summary = `${BASE_API_URL}/Member/GetMemberTotalSummary`;
export const Get_Digital_RamName_Count = `${BASE_API_URL}/DigitalRAMNameTransaction/GetDigitalRamNameCount`;
export const Submit_Digital_Ram_Name = `${BASE_API_URL}/DigitalRAMNameTransaction/SubmitDigitalRamName`;
// ------ here from new updated api for member reg
export const Send_Otp_With_Registration = `${BASE_API_URL}/RamNamBook/Member_Register_SendOtp`;
export const VerifyOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/MemberReg_VerifyOtp`;
export const ResendOtp_RamNamBook = `${BASE_API_URL}/RamNamBook/MemberReg_ResendOtp`;
// --------------------------------------------
export const GET_ACTIVE_MEMBER_TYPE = `${BASE_API_URL}/MemberType/MemberType_GetActiveList`; //Get Member Type Page
// ------------latest api for member registration------------------
export const Send_Otp_With_Registration_New = `${BASE_API_URL}/RamNamBook/Member_Register_SendOtp_New`;

export function sendOtpWithRegistration_NewApi(
  mobileNumber,
  memberName,
  countryID,
  countryCode,
  memberTypeID,
  villageCityName,
  pincode,
  addressAndText,
  termsAccepted,
  password,
) {
  return axios.post(Send_Otp_With_Registration_New, {
    mobileNumber,
    memberName,
    countryID,
    countryCode,
    memberTypeID,
    villageCityName,
    pincode,
    addressAndText,
    termsAccepted,
    password,
  });
}

export function getActiveMemberTypeList() {
  return axios.get(GET_ACTIVE_MEMBER_TYPE);
}

// --------------------------------------------
export function submitDigitalRamNameApi(
  ramNamBookMemberID,
  totalCount,
  deviceTypeID,
) {
  return axios.post(Submit_Digital_Ram_Name, {
    ramNamBookMemberID,
    totalCount,
    deviceTypeID,
  });
}
export function getDigitalRamNameCount(memberId) {
  return axios.get(`${Get_Digital_RamName_Count}?memberId=${memberId}`);
}
export function getMemberTotalSummary(memberId) {
  return axios.get(`${Get_Member_Total_Summary}?memberId=${memberId}`);
}

// ----------------------------------------------------------------
export function sendLoginRamNamOtpApi(mobileNumber) {
  return axios.post(Send_Login_Otp, { mobileNumber });
}
export function verifyLoginRamNamOtpApi(mobileNumber, otp) {
  return axios.post(Verify_Login_Otp, { mobileNumber, otp });
}

export function sendOtpWithRegistrationApi(
  mobileNumber,
  memberName,
  countryID,
  countryCode,
  memberTypeID,
  villageCityName,
  pincode,
  addressAndText,
  termsAccepted,
) {
  return axios.post(Send_Otp_With_Registration, {
    mobileNumber,
    memberName,
    countryID,
    countryCode,
    memberTypeID,
    villageCityName,
    pincode,
    addressAndText,
    termsAccepted,
  });
}
export function verifyRamNamOtpApi(ramNamBookMemberID, otp) {
  return axios.post(VerifyOtp_RamNamBook, { ramNamBookMemberID, otp });
}

// --------------------------------------------
export function getCountryActiveListApi() {
  return axios.get(Get_Countries);
}
export function resendRamNamBookOtpApi(ramNamBookMemberID) {
  return axios.post(ResendOtp_RamNamBook, { ramNamBookMemberID });
}

// export function addRamNamBookMemberApi(
//   memberName,
//   mobileNumber,
//   countryID,
//   villageCityName,
//   pincode,
//   addressAndText,
//   termsAccepted
// ) {
//   return axios.post(Add_RamNamBook_Register_Details, {
//     memberName,
//     mobileNumber,
//     countryID,
//     villageCityName,
//     pincode,
//     addressAndText,
//     termsAccepted,
//   });
// }
